<template>
  <div class="data-type-wrap">
    <router-link :to="{ path: item.url }" :class="[{ 'active': path == item.url }, 'item']"
      v-for="(item, index) in navList" :key="index">{{
        item.name }}</router-link>
  </div>
</template>

<script>

export default {
  name: "ProfileNavbar",
  components: {
  },
  data() {
    return {
      navList: [{
        name: '基本信息',
        url: '/user/profile'
      },
      {
        name: '收件地址',
        url: '/user/address'
      },
      {
        name: '开票信息',
        url: '/invoice/header'
      },
      {
        name: '收款账户',
        url: '/withdraw/account'
      },
      {
        name: '账户安全',
        url: '/user/account'
      }
      ],
    };
  },
  computed: {
    path() {
      return this.$route.path;
    }
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.data-type-wrap {
  display: flex;
  align-items: center;
  column-gap: 25px;

  .item {
    padding: 12px 35px;
    background: #D4EEF6;
    font-size: 16px;
    font-weight: 400;
    color: #00B4E8;
    border-radius: 4px;
    cursor: pointer;
  }

  .active {
    background: #00B4E8;
    color: #FFFFFF;
  }
}
</style>